import { type GetImpulseFormOutput, ImpulseFormShape, ImpulseFormUnit } from "~/tools/impulse-form";

import { DashboardSpec } from "../../../common/dashboard-spec";

import { initSettingsFormState } from "./_settings-menu";
import { initVariablesFormState } from "./_variables";

export function initDashboardFormState(spec: DashboardSpec = DashboardSpec.fromPerses({})) {
	return ImpulseFormShape(
		{
			settings: initSettingsFormState(spec),
			variables: initVariablesFormState(spec),
			panels: ImpulseFormUnit(spec.panels, {
				isInputDirty: (prev, next) => !prev.isEqual(next),
			}),
		},
		{
			/**
			 * There is no explicit "submit" action so the form should validate immediately.
			 * There should be no validation in place but it is better to be safe than sorry.
			 */
			validateOn: "onInit",
		},
	);
}

export type DashboardFormState = ReturnType<typeof initDashboardFormState>;

export function dashboardFormOutputToSpec(output: GetImpulseFormOutput<DashboardFormState>): DashboardSpec {
	return DashboardSpec.of({
		panels: output.panels,
		variables: output.variables,
		refreshInterval: output.settings.refreshInterval.value,
		timeRange: output.settings.timeRange.value,
		saveVariables: output.settings.saveVariables,
	});
}
